import React from 'react'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import { Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'

export const PaymasterWarning = ({ t, setActiveMethod }) => (
  <div className={styles['billing__warning']}>
    <Icon
      className={styles['billing__warning-icon']}
      name={'status warning'}
      color={'Interface-Orange-Primary'}
      width={14}
    />
    <span className={styles['billing__warning-heading']}>
      {t('payment_method_warning_message.heading')}
    </span>
    <span
      className={styles['billing__warning-summary']}
      dangerouslySetInnerHTML={{
        __html: t('payment_method_warning_message.summary'),
      }}
    />

    <button
      onClick={() => setActiveMethod('paymaster_service')}
      className={styles['billing__warning-button']}
      type="button"
      dangerouslySetInnerHTML={{
        __html: t('payment_method_warning_message.button'),
      }}
    />
  </div>
)

PaymasterWarning.propTypes = {
  t: PropTypes.func,
  setActiveMethod: PropTypes.func,
}
